<div class="card-body">
    <div *ngIf="textType=='Sales'">
        <div class="text-bidit-primary-header" i18n>Sales Terms and Conditions</div>
    </div>
  <div *ngIf="textType=='Contract'">
      <div class="text-bidit-primary-header" i18n>Acceptance of Contract</div>
  </div>
  <div *ngIf="textType=='Total'">
      <div class="text-bidit-primary-header" i18n>Total Summary</div>
  </div>

  <form #f="ngForm" (ngSubmit)="saveText(f)">
      <div class="text-bidit-primary">{{textType}} <span i18n>Text (put on all quotes)</span></div>
    <div class="form-group">
      <div>
        <quill-editor [(ngModel)]="noteText" name="noteText" id="noteText"></quill-editor>
      </div>
    </div>
    <div *ngIf="errors" class="row alert alert-danger" role="alert">
      <strong>{{errors}}</strong>
    </div>

    <div>
      <button type="submit" value="submit" name="submit" id="submit" class="btn btn-bidit-action primary btn-md float-right" i18n>Save</button>
    </div>
  </form>
  <br><br>
</div>
